import { Helmet } from 'react-helmet';
import { pdfjs } from 'react-pdf';
import pdf from '../assets/Popisy.pdf';
import pdf1 from '../assets/RRZJ.pdf';
import pdf2 from '../assets/follow_up.pdf';
import pdf3 from '../assets/metodika.pdf';
import pdf4 from '../assets/zpetna_vazba.pdf';
import pdf5 from '../assets/prehled.pdf';
import pdf6 from '../assets/Vokabular.pdf';
import pdf7 from "../assets/Glosář.pdf";
import pdf8 from "../assets/Framework_Reference_SL_Summary.pdf";
import pdf9 from "../assets/RRZJ_shrnutí.pdf";
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import SinglePDF from '../components/PDF/SinglePDF';
import Wrapper from '../components/Wrapper/Wrapper';
import classes from './Download.module.css';
import img from '../assets/pdf.png';


pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const Download = () => {

    return (
        <Wrapper>
            <Helmet>
                <title>Ke stažení</title>
            </Helmet>
            <Breadcrumbs />
            <div className={classes.wrapper}>
                <h2 className={classes.headingTop}>Publikace ke stažení</h2>
                <div className={classes.singlePdf}>
                    <SinglePDF pdf={pdf1} />
                </div>
                <div className={classes.singlePdf}>
                    <SinglePDF pdf={pdf} />
                </div>
                <div className={classes.linksWrapper}>
                    <h2>Ostatní dokumenty</h2>
                    <div className={classes.links}>
                        <a className={classes.pdfLink} href={pdf2}><img className={classes.img} src={img} alt='pdf' />Oblasti následných aktivit (Follow up)</a>
                        <a className={classes.pdfLink} href={pdf3}><img className={classes.img} src={img} alt='pdf' />Metodika zpětné vazby</a>
                        <a className={classes.pdfLink} href={pdf4}><img className={classes.img} src={img} alt='pdf' />Zpětná vazba pro web</a>
                        <a className={classes.pdfLink} href={pdf5}><img className={classes.img} src={img} alt='pdf' />Přehled podnětů pro web</a>
                        <a className={classes.pdfLink} href={pdf6}><img className={classes.img} src={img} alt='pdf' />Vokabulář</a>
                        <a className={classes.pdfLink} href={pdf7}><img className={classes.img} src={img} alt='pdf' />Glosář</a>
                        <a className={classes.pdfLink} href={pdf8}><img className={classes.img} src={img} alt='pdf' />Framework of reference for sign languages: Summary</a>
                        <a className={classes.pdfLink} href={pdf9}><img className={classes.img} src={img} alt='pdf' />RRZJ - shrnutí</a>
                    </div>

                </div>
                <div className={classes.pdfLinks}>
                    <a className={classes.pdfLink} href={pdf1}><img className={classes.img} src={img} alt='pdf' />Referenční rámec znakového jazyka</a>
                    <a className={classes.pdfLink} href={pdf}><img className={classes.img} src={img} alt='pdf' />Popisy</a>
                    <a className={classes.pdfLink} href={pdf6}><img className={classes.img} src={img} alt='pdf' />Vokabulář</a>
                    <a className={classes.pdfLink} href={pdf2}><img className={classes.img} src={img} alt='pdf' />Follow up</a>
                    <a className={classes.pdfLink} href={pdf3}><img className={classes.img} src={img} alt='pdf' />Metodika zpětné vazby</a>
                    <a className={classes.pdfLink} href={pdf4}><img className={classes.img} src={img} alt='pdf' />Zpětná vazba pro web</a>
                    <a className={classes.pdfLink} href={pdf5}><img className={classes.img} src={img} alt='pdf' />Přehled podnětů pro web</a>
                    <a className={classes.pdfLink} href={pdf7}><img className={classes.img} src={img} alt='pdf' />Glosář</a>
                    <a className={classes.pdfLink} href={pdf8}><img className={classes.img} src={img} alt='pdf' />Framework of reference for sign languages: Summary</a>
                    <a className={classes.pdfLink} href={pdf9}><img className={classes.img} src={img} alt='pdf' />RRZJ - shrnutí</a>
                </div>
            </div>
        </Wrapper >

    );
}

export default Download;

